import React from 'react'
import styled from 'styled-components'

const TableCounter = styled.span`
  color: #aab7b8;
  font-weight: 400;
`

export default TableCounter